import { render, staticRenderFns } from "./CashClosureTable.vue?vue&type=template&id=2dd62219&scoped=true"
import script from "./CashClosureTable.vue?vue&type=script&lang=js"
export * from "./CashClosureTable.vue?vue&type=script&lang=js"
import style0 from "./CashClosureTable.vue?vue&type=style&index=0&id=2dd62219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd62219",
  null
  
)

export default component.exports